import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("udp_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("udp_admin_token");
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const login = (email, password) =>
  adminApi.post("/admin/login", { email, password }).then((r) => r.data);

export const me = () => adminApi.get("/admin/me").then((r) => r.data);

export const listInquiries = () =>
  adminApi.get("/admin/inquiries").then((r) => r.data);

export const updateStatus = (id, status) =>
  adminApi.patch(`/admin/inquiries/${id}`, { status }).then((r) => r.data);

export const deleteInquiry = (id) =>
  adminApi.delete(`/admin/inquiries/${id}`).then((r) => r.data);
